import {
  getErrors,
  loading,
  setBalance,
  setChannels,
  setExportRoute,
  setPaginator,
  setPayment,
  setTickets,
  setValidatedBank,
  transactions,
} from '@/reducers/ots';
import { headers } from '@/services/headers';
import { ThunkAction } from '@reduxjs/toolkit';
import axios from 'axios';
import toast from 'react-hot-toast';
import { RootState } from '../store';

export const GetOtsTransactionsByEvent =
  (code?: string, query?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          code +
          '/ots/sales?filter[search]=' +
          query,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(transactions(response.data.data));
        dispatch(setPaginator(response.data.meta));
        dispatch(setExportRoute(response.data.export_route));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const GetOtsTickets =
  (code?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL + '/org/events/' + code + '/ots/tickets',
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setTickets(response.data.data));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const ShowBalance =
  (code?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          code +
          '/ots/guarantee',
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setBalance(response.data.data.balance));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const GetOtsPaymentChannels =
  (code?: string): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .get(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          code +
          '/ots/payment-channels',
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setChannels(response.data.data));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const PayTicket =
  (
    eventId?: string,
    attributes?: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          eventId +
          '/ots/sales',
        attributes,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setPayment(response.data.data));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const TopupGuarantee =
  (
    eventId?: string,
    attributes?: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          eventId +
          '/ots/guarantee/topup',
        attributes,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(
          setPayment({
            redirect_uri: response.data.data.snapToken,
          })
        );
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const WithdrawGuarantee =
  (
    eventId?: string,
    attributes?: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          eventId +
          '/ots/guarantee/withdraw',
        attributes,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        toast.success('Berhasil melakukan penarikan saldo jaminan');
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const CheckBankAccount =
  (
    eventId?: string,
    attributes?: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    const response = axios
      .post(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          eventId +
          '/ots/guarantee/validate-bank',
        attributes,
        {
          headers: headers(),
        }
      )
      .then((response) => {
        dispatch(setValidatedBank(response.data.data));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );
      });

    dispatch(loading(false));

    return response;
  };

export const StoreBulkCheckout =
  (
    eventId?: string,
    attributes?: any
  ): ThunkAction<void, RootState, unknown, any> =>
  async (dispatch: any) => {
    dispatch(loading(true));

    return axios
      .post(
        process.env.REACT_APP_BASE_URL +
          '/org/events/' +
          eventId +
          '/ots/sales/bulk-checkout',
        attributes,
        {
          headers: { ...headers(), 'Content-Type': 'multipart/form-data' },
        }
      )
      .then((response) => {
        dispatch(loading(false));
      })
      .catch((error: any) => {
        const { errors, message } = error.response.data.error;

        dispatch(
          getErrors({
            errorMsg: message,
            errors: errors,
          })
        );

        dispatch(loading(false));
      });
  };
